import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const jsonPost = (url, body) => {
    return apiWrapper({
      fetch,
      url,
      options: {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      }
    });
  }

  const fetchAssetList = async (prefix = '') => {
    return apiWrapper({
      fetch,
      url: `asset/manage/list?prefix=${encodeURIComponent(prefix)}`,
      options: { method: 'GET' }
    });
  }

  const uploadAssetFiles = async (folder, files, overwrite = false) => {
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file); });
    formData.append('folder', folder || '');
    formData.append('overwrite', overwrite ? 'true' : 'false');
    return apiWrapper({
      fetch,
      url: 'asset/manage/upload',
      options: { method: 'POST', body: formData }
    });
  }

  const createFolder = async (path) => {
    return jsonPost('asset/manage/folder/create', { path });
  }

  const deleteFolder = async (path) => {
    return jsonPost('asset/manage/folder/delete', { path });
  }

  const renameFolder = async (path, newName) => {
    return jsonPost('asset/manage/folder/rename', { path, newName });
  }

  const deleteFile = async (key) => {
    return jsonPost('asset/manage/file/delete', { key });
  }

  const moveFile = async (sourceKey, destinationFolder, overwrite = false) => {
    return jsonPost('asset/manage/file/move', { sourceKey, destinationFolder, overwrite });
  }

  const renameFile = async (key, newName, overwrite = false) => {
    return jsonPost('asset/manage/file/rename', { key, newName, overwrite });
  }

  return {
    fetchAssetList,
    uploadAssetFiles,
    createFolder,
    deleteFolder,
    renameFolder,
    deleteFile,
    moveFile,
    renameFile
  }
}
